import { render, staticRenderFns } from "./AIPrediction.vue?vue&type=template&id=0b9db183&scoped=true"
import script from "./AIPrediction.vue?vue&type=script&lang=js"
export * from "./AIPrediction.vue?vue&type=script&lang=js"
import style0 from "./AIPrediction.vue?vue&type=style&index=0&id=0b9db183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9db183",
  null
  
)

export default component.exports